import React from 'react'

import ImportItem from '@/components/import/ImportItem';
import AppHeader from "@/components/header/AppHeader";

function Import() {
    return (
        <div className="import app-page">
            <AppHeader title="Импорт данных из Kinopoisk/IMDB" />

            <div className="app-container">
                <ImportItem />
            </div>
        </div>
    )
}

export default Import